import { Box, styled, Paper } from "@mui/material";

export const Container = styled(Box)(() => ({
  display: "flex",
  maxHeight: "100vh",
  height: "100%",
  width: "100%",
}));
